import { jsx, jsxs } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const ArrowIcon = ({
  color = "currentColor",
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 32),
    viewBox: "0 0 32 32",
    ...svgProps,
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      transform: "translate(1 1)",
      children: [/*#__PURE__*/jsx("path", {
        d: "M8.571 15h12.857M13.928 20.357L8.57 14.996l5.357-5.357"
      }), /*#__PURE__*/jsx("circle", {
        cx: "15",
        cy: "15",
        r: "15"
      })]
    })
  });
};

export { ArrowIcon };
//# sourceMappingURL=arrow.js.map
